import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import firebase from '../tools/firebase';
import logo from '../assets/LaunchScreen@2x.png';
import bg from '../assets/revolt-geeZzrAXyMQ-unsplash.jpg';
import Footer from '../components/Footer';
import style from '../style/admin.module.css';

const AdminLogin = ({ history }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password);
            history.push('/admin/dashboard');
        } catch {
            setError('Invalid email or password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={style.loginPage} style={{ backgroundImage: `url(${bg})` }}>
            <div className={style.loginOverlay} />

            {/* flex: 1 — grows to fill the page, centers the card */}
            <div className={style.loginCenter}>
                <div className={style.loginCard}>
                    <img src={logo} alt="Grub Trucks" className={style.loginLogo} />
                    <h2 className={style.loginTitle}>Owner Portal</h2>
                    <p className={style.loginSubtitle}>Manage your truck, menu &amp; schedule</p>

                    {error && <Alert variant="danger" className={style.loginAlert}>{error}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="adminEmail">
                            <Form.Label className={style.fieldLabel}>Email</Form.Label>
                            <Form.Control
                                className={style.fieldInput}
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="adminPassword">
                            <Form.Label className={style.fieldLabel}>Password</Form.Label>
                            <Form.Control
                                className={style.fieldInput}
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </Form.Group>
                        <Button type="submit" className={style.loginBtn} disabled={loading} block>
                            {loading ? 'Signing in…' : 'Sign In →'}
                        </Button>
                    </Form>
                </div>
            </div>

            {/* Footer always at the very bottom */}
            <div className={style.loginFooterWrap}>
                <Footer />
            </div>
        </div>
    );
};

export default AdminLogin;
